import { Form, Formik } from 'formik';

import { useUpdatePortainerMutation } from '@/react/portainer/system/useUpdatePortainerMutation';
import { notifySuccess } from '@/portainer/services/notifications';

import { Button, LoadingButton } from '@@/buttons';
import { Modal } from '@@/modals/Modal';
import { Link } from '@@/Link';
import { Alert } from '@@/Alert';

const initialValues = {};

export function UpdateConfirmDialog({
  onDismiss,
  goToLoading,
}: {
  onDismiss: () => void;
  goToLoading: () => void;
}) {
  const updateMutation = useUpdatePortainerMutation();

  return (
    <Modal
      onDismiss={onDismiss}
      aria-label="Update Portainer to the latest version"
    >
      <Modal.Header
        title={<h4 className="text-xl font-medium">Update Portainer</h4>}
      />
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnMount
      >
        {() => (
          <Form noValidate>
            <Modal.Body>
              <p className="mb-4">
                Updating Portainer will necessitate a restart. You will be
                logged out and need to log in again once the update is complete.
                Are you sure you want to update Portainer?
              </p>

              <Alert color="warn">
                <span>
                  Before updating to the new Portainer version, please ensure
                  you have{' '}
                  <Link
                    data-cy="backup-link"
                    to="portainer.settings"
                    params={{ section: 'backup-settings' }}
                    target="_blank"
                    rel="noreferrer"
                    className="!text-inherit underline hover:!text-inherit"
                  >
                    backed up
                  </Link>{' '}
                  your current system.
                </span>
              </Alert>
            </Modal.Body>
            <Modal.Footer>
              <div className="flex w-full gap-2 [&>*]:w-1/2">
                <Button
                  color="default"
                  data-cy="update-cancel-button"
                  size="medium"
                  className="w-full"
                  onClick={onDismiss}
                >
                  Dismiss
                </Button>
                <LoadingButton
                  color="primary"
                  data-cy="confirm-update-start-button"
                  size="medium"
                  loadingText="Starting update..."
                  isLoading={updateMutation.isLoading}
                >
                  Start update
                </LoadingButton>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );

  function handleSubmit() {
    updateMutation.mutate(undefined, {
      onSuccess() {
        notifySuccess('Success', 'Starting update');
        goToLoading();
      },
    });
  }
}
